// Central data for company/services/industries
import {
  Globe, ShoppingBag, Code2, Smartphone, Cpu, Database, Cloud, Palette, Megaphone, LifeBuoy,
  HeartPulse, GraduationCap, Building2, HardHat, Factory, HeartHandshake, UtensilsCrossed, ShoppingCart, Truck, Rocket,
  Layers, BrainCircuit, Zap, Paintbrush,
} from "lucide-react";

export const COMPANY_INFO = {
  name: "Easyworks Industries Pvt. Ltd.",
  shortName: "Easyworks",
  tagline: "One Company. Multiple Solutions.",
  offices: [
    {
      key: "india",
      label: "Head Office — India",
      short: "India (Head Office)",
      address: "India",
      phone: "+91 9473037564",
      phoneDial: "+919473037564",
    },
    {
      key: "uae",
      label: "Regional Office — UAE",
      short: "UAE (Regional Office)",
      address: "United Arab Emirates",
      phone: "+971 50 283 9619",
      phoneDial: "+971502839619",
    },
  ],
  // Primary numbers used in headers/CTAs
  phone: "+91 9473037564",
  phoneDial: "+919473037564",
  phoneUAE: "+971 50 283 9619",
  phoneUAEDial: "+971502839619",
  addressShort: "India · UAE",
  email: "info@easyworksindustries.com",
  website: "www.easyworksindustries.com",
  socials: {
    linkedin: "#",
    instagram: "#",
    facebook: "#",
    youtube: "#",
  },
};

export const COMPANIES = [
  {
    key: "digital",
    name: "Easyworks Digital",
    tag: "Digital Solutions",
    icon: Globe,
    color: "from-blue-500 to-blue-700",
    description: "Websites, E-Commerce, Portals, UI/UX and Digital Presence Solutions.",
  },
  {
    key: "software",
    name: "Easyworks Software",
    tag: "Business Applications",
    icon: Layers,
    color: "from-orange-500 to-red-500",
    description: "ERP, CRM, HRMS and Custom Software for all business needs.",
  },
  {
    key: "ai",
    name: "Easyworks AI",
    tag: "Intelligent Automation",
    icon: BrainCircuit,
    color: "from-fuchsia-500 to-purple-600",
    description: "AI Chatbots, Automation, Document AI and Smart Business Solutions.",
  },
  {
    key: "cloud",
    name: "Easyworks Cloud",
    tag: "Cloud & DevOps",
    icon: Cloud,
    color: "from-sky-400 to-blue-500",
    description: "Cloud Infrastructure, DevOps, Security, Backup and Disaster Recovery.",
  },
  {
    key: "creative",
    name: "Easyworks Creative",
    tag: "Design & Branding",
    icon: Paintbrush,
    color: "from-emerald-500 to-teal-600",
    description: "Branding, Design, Video, Content and Creative Solutions.",
  },
  {
    key: "marketing",
    name: "Easyworks Marketing",
    tag: "Growth & Visibility",
    icon: Megaphone,
    color: "from-rose-500 to-pink-600",
    description: "Digital Marketing, SEO, Ads, Social Media and Lead Generation.",
  },
];

export const SERVICES = [
  { key: "web", title: "Website Development", icon: Globe, desc: "Modern, responsive and SEO-friendly websites that convert visitors into customers." },
  { key: "ecom", title: "E-Commerce Solutions", icon: ShoppingBag, desc: "Powerful online stores with secure payment gateways and smooth user experience." },
  { key: "custom", title: "Custom Software", icon: Code2, desc: "Tailored software solutions that streamline operations and improve efficiency." },
  { key: "mobile", title: "Mobile App Development", icon: Smartphone, desc: "Android, iOS and cross-platform apps for businesses and startups." },
  { key: "ai", title: "AI Automation", icon: Cpu, desc: "AI chatbots, workflow automation, document AI and intelligent business solutions." },
  { key: "erp", title: "ERP & CRM Solutions", icon: Database, desc: "End-to-end ERP, CRM, HRMS and industry-specific business management systems." },
  { key: "cloud", title: "Cloud & DevOps", icon: Cloud, desc: "Scalable cloud infrastructure, DevOps, CI/CD, security and monitoring." },
  { key: "uiux", title: "UI/UX Design", icon: Palette, desc: "User-centric design that creates engaging digital experiences and strong branding." },
  { key: "marketing", title: "Digital Marketing", icon: Megaphone, desc: "SEO, Google Ads, Social Media, Email Marketing and Lead Generation." },
  { key: "support", title: "Maintenance & Support", icon: LifeBuoy, desc: "Ongoing maintenance, security updates and 24/7 technical support." },
];

export const INDUSTRIES = [
  { key: "healthcare", name: "Healthcare", icon: HeartPulse },
  { key: "education", name: "Education", icon: GraduationCap },
  { key: "realestate", name: "Real Estate", icon: Building2 },
  { key: "construction", name: "Construction", icon: HardHat },
  { key: "manufacturing", name: "Manufacturing", icon: Factory },
  { key: "ngo", name: "NGO & Trusts", icon: HeartHandshake },
  { key: "hospitality", name: "Hospitality", icon: UtensilsCrossed },
  { key: "retail", name: "Retail & E-Commerce", icon: ShoppingCart },
  { key: "logistics", name: "Logistics", icon: Truck },
  { key: "startups", name: "Startups", icon: Rocket },
];

export const STATS = [
  { value: "10+", label: "Projects Delivered" },
  { value: "10+", label: "Happy Clients" },
  { value: "5+", label: "Expert Professionals" },
  { value: "2", label: "Global Offices" },
  { value: "100%", label: "Client Commitment" },
];

export const WHY_POINTS = [
  { title: "Business-Oriented Solutions", desc: "We build solutions that solve real business problems." },
  { title: "On-Time Delivery", desc: "We follow a proven process to deliver projects on time." },
  { title: "Quality & Security", desc: "We follow industry best practices to ensure quality and security." },
  { title: "Experienced Creative Design & Creativa", desc: "Skilled professionals with deep industry knowledge." },
  { title: "Quality & Security", desc: "We follow a proven process to deliver projects on time." },
  { title: "Long-Term Support", desc: "We are with you even after project delivery for continuous support." },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/companies", label: "Companies" },
  { to: "/services", label: "Services" },
  { to: "/industries", label: "Industries" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/case-studies", label: "Case Studies" },
  { to: "/resources", label: "Resources" },
  { to: "/contact", label: "Contact Us" },
];
